import { Mail, MapPin, Phone, Globe, Shield } from 'lucide-react'

// Agency info
const AGENCY_LOGO = 'https://www.immosanremo.com/wp-content/uploads/2023/04/immo-sanremo-logo-23-footer.png'
const AGENCY_NAME = 'ImmoSanremo'
const AGENCY_ADDRESS = 'Corso Matuzia, 22'
const AGENCY_CITY = 'SANREMO (IMPERIA)'
const AGENCY_CAP = '18038'
const AGENCY_PHONE = '+39 0184 610689'
const AGENCY_EMAIL = 'info@immosanremo.com'
const AGENCY_WEBSITE = 'https://www.immosanremo.com'

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Agency Brand */}
          <div>
            <img
              src={AGENCY_LOGO}
              alt={AGENCY_NAME}
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm text-gray-400">
              Valutazioni immobiliari professionali basate sui dati reali
              del compravenduto degli ultimi 12 mesi per Sanremo e la Riviera dei Fiori.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contatti Agenzia</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-primary-500 mt-0.5 shrink-0" />
                <span>
                  {AGENCY_ADDRESS}<br />
                  {AGENCY_CITY} - CAP {AGENCY_CAP}
                </span>
              </li>
              <li>
                <a href={`tel:${AGENCY_PHONE}`} className="flex items-center gap-2 hover:text-white transition-colors">
                  <Phone className="h-4 w-4 text-primary-500" />
                  {AGENCY_PHONE}
                </a>
              </li>
              <li>
                <a href={`mailto:${AGENCY_EMAIL}`} className="flex items-center gap-2 hover:text-white transition-colors">
                  <Mail className="h-4 w-4 text-primary-500" />
                  {AGENCY_EMAIL}
                </a>
              </li>
              <li>
                <a href={AGENCY_WEBSITE} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors">
                  <Globe className="h-4 w-4 text-primary-500" />
                  www.immosanremo.com
                </a>
              </li>
            </ul>
          </div>

          {/* Disclaimer */}
          <div>
            <h3 className="text-white font-semibold mb-4">Note legali</h3>
            <div className="space-y-3 text-sm text-gray-400">
              <p className="flex items-start gap-2">
                <Shield className="h-4 w-4 text-primary-500 mt-0.5 shrink-0" />
                <span>Dati tratti dal compravenduto degli ultimi 12 mesi</span>
              </p>
              <p>
                Le valutazioni fornite sono indicative e basate su dati statistici.
                Non costituiscono perizia estimativa ufficiale.
              </p>
              <p className="text-primary-400 font-medium">
                Per una valutazione professionale, contatta la nostra agenzia.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500 space-y-1">
          <p>© {new Date().getFullYear()} {AGENCY_NAME} - Tutti i diritti riservati</p>
          <p>
            Software sviluppato da Andrea Piani —{' '}
            <a
              href="https://www.andreapiani.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors underline"
            >
              www.andreapiani.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}
